export const CONFIG = {
    apiKey: "AIzaSyAzNV3aRPF7Ko2v6da_2-0It6nj8hMpbt8",
    authDomain: "melhorprato-79eeb.firebaseapp.com",
    databaseURL: "https://melhorprato-79eeb.firebaseio.com",
    projectId: "melhorprato-79eeb",
    storageBucket: "melhorprato-79eeb.appspot.com",
    messagingSenderId: "568709714905"
}